import React, { useEffect, useState } from 'react';

import './BaseNewsPrompt.scss';
import Modal from 'react-modal';
import Button from '../../Forms/Button';


export interface BaseNewsPromptProps {
    openTrigger: boolean;
    onClose?: () => void;
    singleShow?: boolean;
    // Content
    title: string;
    closeText?: string;
    children: JSX.Element;
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '90vh',
        border: 'none',
        background: 'transparent',
        perspective: '1000px',
        overflow: 'visible',
        padding: '0px',
    }
};

const BaseNewsPrompt = ({
    openTrigger,
    singleShow = true,
    title = '',
    onClose,
    closeText = 'Cerrar',
    children = null
}: BaseNewsPromptProps) => {
    const [isOpen, setIsOpen] = useState<true | false | null>(null);

    useEffect(() => {
        // Only trigger this prompt once per load
        if (openTrigger && singleShow) {
            setIsOpen((iO) => {
                if (iO === null) {
                    return true;
                }
                return iO;
            });
        } else if (!singleShow) {
            // else, use direct trigger drive
            setIsOpen(openTrigger);
        }
    }, [openTrigger, singleShow]);

    const handleClose = () => {
        onClose();
        setIsOpen(false);
    }

    return (
        <Modal
            isOpen={isOpen || false}
            onRequestClose={handleClose}
            style={customStyles}
            ariaHideApp={false}
            shouldCloseOnEsc={true}
            shouldCloseOnOverlayClick={false}
            contentLabel="Assisted bank retry dialog"
        >
            <div id="BaseNewsPrompt" className='card table'>
                <div className="cardTitle">
                    <h4>{title}</h4>
                </div>
                <div className="cardBody">
                    {children}
                    <div className='row _ctaButtons'>
                        <div className='row'>
                            <Button primary={true} handleClick={handleClose}>
                                <span>
                                    {closeText}
                                </span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default BaseNewsPrompt;